'use client'

import React from 'react'

type Props = {
    initialVelocity: number
    acceleration: number
    timeS: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 40
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function DisplacementTimeChart({ initialVelocity, acceleration, timeS }: Props) {
    const u = initialVelocity
    const a = acceleration
    const totalTime = Math.max(timeS, 0.0001)

    const points: string[] = []
    const steps = 60
    const sAt = (time: number) => u * time + 0.5 * a * time * time

    let maxS = 0
    let minS = 0
    for (let i = 0; i <= steps; i++) {
        const time = (totalTime * i) / steps
        const s = sAt(time)
        if (s > maxS) maxS = s
        if (s < minS) minS = s
    }
    if (maxS === minS) maxS = minS + 1

    const xToSvg = (time: number) => PAD_LEFT + (time / totalTime) * PLOT_W
    const yToSvg = (s: number) => PAD_TOP + PLOT_H - ((s - minS) / (maxS - minS)) * PLOT_H

    for (let i = 0; i <= steps; i++) {
        const time = (totalTime * i) / steps
        points.push(`${xToSvg(time).toFixed(1)},${yToSvg(sAt(time)).toFixed(1)}`)
    }

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Time (s)</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Displacement (m)</text>
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            <circle cx={xToSvg(totalTime)} cy={yToSvg(sAt(totalTime))} r={4} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
